import React, { useEffect, useState } from 'react';
import TanoEdLogo from '../../assets/logoTanoEd.png';
import { url } from '../../utils/confserveur';
import { useUser } from '../../context/UserContext';
import SelectEtablissement from '../SelectEtablissement';
const CallbackGar = () => {
    const [searchParams] = useState(new URLSearchParams(window.location.search));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
    const {selectedEtablissementId, setSelectedEtablissementId, setEtablissementAndWait} = useUser();
       useEffect(() => {
        const handleGarCallback = async () => {
            try {
                // Vérifier les paramètres d'URL
                const errorParam = searchParams.get('error');
                const authStatus = searchParams.get('auth_status');
                const authType = searchParams.get('auth_type');
                const tempCode = searchParams.get('code');

                // Si erreur directe du GAR
                if (errorParam) {
                    setError(errorParam);
                    setLoading(false);
                    setStatus('error');
                    return;
                }

                // Si authentification réussie
                if (authStatus === 'success' && authType === 'gar' && tempCode) {
                    
                    try {
                        // Échanger le code contre les tokens
                        const exchangeResult = await exchangeCodeForTokens(tempCode);
                        
                        if (exchangeResult.success) {
                            const userData = exchangeResult.user;

                            // Nettoyer le localStorage avant de stocker les nouvelles données
                            localStorage.clear();

                            localStorage.setItem('id_user', userData.id_user);
                            localStorage.setItem('iduser', userData.id);
                            localStorage.setItem('username', userData.username);
                            localStorage.setItem('email', userData.email);
                            localStorage.setItem('first_name', userData.first_name);
                            localStorage.setItem('last_name', userData.last_name);
                            localStorage.setItem('role', userData.role);
                            localStorage.setItem('matiere', userData.matiere);
                            localStorage.setItem('etablissement_id', userData.etablissement_id);
                            localStorage.setItem('etablissement_nom', userData.etablissement_nom);
                            localStorage.setItem('authType', 'gar');
                            localStorage.setItem('auth_type', userData.auth_type);                           
                            // On garde aussi l'objet complet pour compatibilité si nécessaire
                            localStorage.setItem('user', JSON.stringify(userData));

                            setStatus('success');
                            setLoading(false);
                            
                            // Redirection après 2 secondes
                            setTimeout(() => {
                                window.location.href = '/home';
                            }, 2000);
                        } else {
                            throw new Error('Échec de l\'échange du code');
                        }
                    } catch (err) {
                        console.error('❌ Erreur échange:', err);
                        setError('authentication_error');
                        setLoading(false);
                        setStatus('error');
                    }
                } else {
                    // Paramètres invalides
                    setError('invalid_parameters');
                    setLoading(false);
                    setStatus('error');
                }
            } catch (err) {
                console.error('❌ Erreur callback:', err);
                setError('authentication_error');
                setLoading(false);
                setStatus('error');
            }
        };

        handleGarCallback();
    }, [searchParams]);

    const exchangeCodeForTokens = async (code) => {
    
        
        
        // ✅Nettoyer les anciens cookies AVANT l'échange
        // Supprimer tous les cookies d'authentification côté client car il peut garder des cookies blacklister.
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tanoed.com; SameSite=None; Secure";
        document.cookie = "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tanoed.com; SameSite=None; Secure";
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure";
        document.cookie = "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure";
        const response = await fetch(`${url}api/gar/exchange-token/`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code })
        });

        if (!response.ok) {
            const errorData = await response.text();
            console.error('❌ Erreur échange:', errorData);
            throw new Error('Échec de l\'échange du code');
        }

        const data = await response.json();
       
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
        
        return data;
    };

    // Affichage du loader
    if (loading && status === 'loading') {
        return (
            <div className="min-h-screen fixed inset-0 flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
                <div className="text-center">
                    <div className="relative w-20 h-20 mx-auto mb-6">
                        <div className="absolute inset-0 border-4 border-blue-200 rounded-full"></div>
                        <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
                    </div>
                    <p className="text-blue-800 text-lg font-medium">Connexion en cours...</p>
                </div>
            </div>
        );
    }

    // Affichage du succès
    if (!loading && status === 'success') {
        return (
            <div className="min-h-screen fixed inset-0 flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100">
                <div className="text-center">
                    <div className="mb-6">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-500 rounded-full">
                            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                    </div>
                    <h2 className="text-2xl font-bold text-green-800 mb-2">Connexion réussie !</h2>
                    <p className="text-green-600">Redirection en cours...</p>
                </div>
            </div>
        );
    }

    // Affichage des erreurs
    if (!loading && status === 'error') {
        const errorMessages = {
            'etablissement_non_souscrit': {
                title: "Établissement non abonné",
                message: "Votre établissement n'est pas encore abonné à TanoEd.",
                details: "Pour bénéficier de notre plateforme, votre établissement doit souscrire à notre offre. Contactez votre administration pour plus d'informations.",
                icon: "🏫"
            },
            'claims_invalides': {
                title: "Informations incomplètes",
                message: "Les informations fournies par le GAR sont incomplètes.",
                details: "Veuillez contacter votre administrateur système.",
                icon: "⚠️"
            },
            'matiere_non_autorisee': {
                title: "Matière non disponible",
                message: "Votre matière n'est pas encore prise en charge sur TanoEd.",
                details: "Actuellement, seuls les professeurs de Mathématiques et de Français peuvent accéder à la plateforme. D'autres matières seront ajoutées prochainement.",
                icon: "🔜"
            },
            'authentication_failed': {
                title: "Échec de connexion",
                message: "La connexion via le GAR a échoué.",
                details: "Veuillez réessayer ou utiliser la connexion standard.",
                icon: "❌"
            },
            'authentication_error': {
                title: "Erreur technique",
                message: "Une erreur technique s'est produite lors de la connexion.",
                details: "Veuillez réessayer dans quelques instants.",
                icon: "🔧"
            },
            'invalid_parameters': {
                title: "Paramètres invalides",
                message: "Les paramètres de connexion sont invalides.",
                details: "Veuillez retourner au GAR et réessayer.",
                icon: "🔗"
            }
            ,
            'professeur_polyvalent_non_supporte': {
                title: "Profil non supporté",
                message: "TanoEd ne prend pas encore en charge les professeurs polyvalents.",
                details: "Les professeurs enseignant à la fois les Mathématiques et le Français ne peuvent pas accéder à la plateforme pour le moment.",
                icon: "🚫"
            },
            "classe_non_creee": {
                 title: "Votre classe n'est pas encore disponible sur TanoEd.",
                message: "Demandez à votre professeur de mathématiques ou de français de se connecter en premier pour initialiser la classe.",
                details: "Vous pourrez ensuite vous connecter.",
                icon: "🚫"
            }
        };

        const errorInfo = errorMessages[error] || {
            title: "Erreur de connexion",
            message: "Une erreur inattendue s'est produite.",
            details: "Veuillez réessayer ultérieurement ou contacter le support.",
            icon: "⚠️"
        };

        return (
            <div className="min-h-screen fixed inset-0 bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
                <div className="max-w-md w-full">
                    {/* Logo TanoEd */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center mb-4">
                            <img 
                                src={TanoEdLogo}
                                alt="TanoEd Logo" 
                                className="w-32 h-32 mx-auto mb-4"
                            />
                        </div>
                    </div>

                    {/* Carte d'erreur */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                        {/* En-tête coloré */}
                        <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 text-white">
                            <div className="flex items-center space-x-3">
                                <span className="text-4xl">{errorInfo.icon}</span>
                                <h2 className="text-2xl font-bold">{errorInfo.title}</h2>
                            </div>
                        </div>

                        {/* Contenu */}
                        <div className="p-6 space-y-4">
                            <p className="text-gray-800 text-lg font-medium">
                                {errorInfo.message}
                            </p>
                            <p className="text-gray-600">
                                {errorInfo.details}
                            </p>

                            {/* Actions */}
                            <div className="pt-4 space-y-3">
                                <p 
   className="w-full text-blue-600 hover:text-blue-700 hover:underline  font-medium py-3 px-6 text-center transition-colors duration-200"
>
   Tenter de vous connecter à nouveau via l'ENT
</p>
                                
                                {error === 'etablissement_non_souscrit' && (
                                    <button 
                                        onClick={() => window.open('https://tanoed.com/contact', '_blank')}
                                        className="w-full bg-white hover:bg-gray-50 text-blue-600 font-medium py-3 px-6 rounded-lg border-2 border-blue-600 transition-colors duration-200"
                                    >
                                        Contacter TanoEd
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Pied de page */}
                        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                            <p className="text-sm text-gray-500 text-center">
                                Besoin d'aide ? Contactez votre administrateur ou le support TanoEd
                            </p>
                        </div>
                    </div>

                    {/* Message de redirection automatique */}
                    <div className="mt-6 text-center">
                        <p className="text-sm text-gray-600">
                            Vous serez redirigé automatiquement dans quelques secondes...
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default CallbackGar;